import i18n from "shared/i18n";
import * as yup from "yup";

export function getJobRelatedExpenseFieldsYupOnSaveSchema() {
  return {
    is_job_related: yup.boolean(),
    sap_vendor_number: yup
      .string()
      .when("is_job_related", (isJobRelated, schema) =>
        isJobRelated
          ? schema
              .length(
                10,
                i18n.t("validations.sap_vendor_number.length", {
                  ns: "CostLine",
                })
              )
              .test(
                "starts_with",
                i18n.t("validations.sap_vendor_number.starts_with", {
                  ns: "CostLine",
                }),
                (value) => value?.startsWith("64")
              )
          : schema.notRequired()
      ),
    invoice_number: yup
      .string()
      .when("is_job_related", (isJobRelated, schema) =>
        isJobRelated
          ? schema.max(
              20,
              i18n.t("validations.invoice_number.max", {
                ns: "CostLine",
              })
            )
          : schema.notRequired()
      ),
  };
}
